import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EvaluationContext } from '../models/feature-flag.model';

/**
 * Service that manages the user context for feature flag evaluation
 */
@Injectable({
  providedIn: 'root',
})
export class FeatureFlagContextService {
  private contextSubject = new BehaviorSubject<EvaluationContext>({});

  /**
   * Observable of the current user context
   */
  readonly context$: Observable<EvaluationContext> = this.contextSubject.asObservable();

  /**
   * Set the entire user context
   * @param context The complete user context
   */
  setContext(context: EvaluationContext): void {
    this.contextSubject.next(context);
  }

  /**
   * Patches parts of the user context while preserving other values
   */
  patchContext(contextUpdate: Partial<EvaluationContext>): void {
    const currentContext = this.contextSubject.getValue();
    this.contextSubject.next({
      ...currentContext,
      ...contextUpdate,
    });
  }

  /**
   * Get the current user context
   */
  getCurrentContext(): EvaluationContext {
    return this.contextSubject.getValue();
  }

  /**
   * Clear the user context
   */
  clearContext(): void {
    this.contextSubject.next({});
  }
}
